export enum FeatureFlagEnum {
  CreditReportClientTabs = 'CreditReportClientTabs',
  CreditReportSettings = 'CreditReportSettings',
  PreCompletions = 'PreCompletions',
  GlobalSearch = 'GlobalSearch',
  EmailPreviewer = 'EmailPreviewer',
  MabTheme = 'MabTheme',
  ActivityLog = 'ActivityLog',
}
